import { useCallback, useState } from "react";
import { TablePaginationConfig } from "antd";
import { PAGINATION } from "common/enums/Pagination.enum";

export const usePagination = (
  initialPage = PAGINATION.PAGE,
  initialPageSize = PAGINATION.LIMIT,
) => {
  const [pagination, setPagination] = useState({
    current: initialPage,
    pageSize: initialPageSize,
    total: 0,
    showSizeChanger: false,
  });

  const [paginationMobile, setPaginationMobile] = useState({
    current: initialPage,
    pageSize: initialPageSize,
    total: 0,
    showSizeChanger: false,
    onChange: (page: number) => {
      onChangePageMobile(page);
    },
  });

  const onChangePage = useCallback((pagination: TablePaginationConfig) => {
    setPagination((prev) => ({ ...prev, current: pagination.current ?? 1 }));
  }, []);

  const onChangePageMobile = useCallback((page: number) => {
    setPaginationMobile((prev) => ({ ...prev, current: page ?? 1 }));
  }, []);

  const reset = useCallback(() => {
    setPagination((prev) => ({ ...prev, current: PAGINATION.PAGE }));
  }, []);

  const resetMobile = useCallback(() => {
    setPaginationMobile((prev) => ({ ...prev, current: PAGINATION.PAGE }));
  }, []);

  const updateTotal = useCallback((total: number) => {
    setPagination((prev) => ({ ...prev, total }));
  }, []);

  const updateTotalMobile = useCallback((total: number) => {
    setPaginationMobile((prev) => ({ ...prev, total }));
  }, []);

  return {
    pagination,
    setPagination,
    paginationMobile,
    setPaginationMobile,
    onChangePage,
    onChangePageMobile,
    reset,
    resetMobile,
    updateTotal,
    updateTotalMobile,
  };
};
